import { render, staticRenderFns } from "./BnTarifaPageSection.vue?vue&type=template&id=44aaf678&scoped=true&"
import script from "./BnTarifaPageSection.vue?vue&type=script&lang=js&"
export * from "./BnTarifaPageSection.vue?vue&type=script&lang=js&"
import style0 from "./BnTarifaPageSection.vue?vue&type=style&index=0&id=44aaf678&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaf678",
  null
  
)

export default component.exports